import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * Shown when the `/billingo` responses predate the order-context release.
 *
 * The dashboard deploys independently of the Billingo Lambda, so the UI can run
 * ahead of it. Without this the missing data reads as real — blank customers,
 * unknown issuers, zeroed values — which is worse than an outright error,
 * because nothing looks wrong.
 */
function StaleApiNotice({ show = false, detail = '' }) {
  if (!show) return null;
  return (
    <Alert variant="warning" className="py-2 small">
      <i className="fa fa-triangle-exclamation me-2" />
      The invoicing API is running an older version, so
      {` ${detail || 'order context and issuer details'} `}
      are unavailable here. Deploy the Billingo Lambda to populate them.
    </Alert>
  );
}

export default StaleApiNotice;
